var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoBackgroundIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 179,
    viewBox: "0 0 179 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.000732422,
    width: 178.983,
    height: 178.983,
    rx: 89.4915,
    fill: "#00DA93"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      transform: "translateX(-25px) translateY(-33px) scale(1.4)"
    },
    d: "M112.361 98.1539L93.7513 91.9314C90.99 91.0065 90.99 86.9851 93.7513 86.0603L112.361 79.8377C113.605 79.4234 114.288 78.0467 113.882 76.7661L112.434 72.1798C112.031 70.8993 110.693 70.1962 109.449 70.6147L90.8395 76.8373C88.0781 77.7621 85.7804 74.5064 87.4844 72.0877L98.9852 55.7968C99.7538 54.7088 99.5179 53.1814 98.4606 52.3905L94.6663 49.5533C93.609 48.7624 92.1246 49.0051 91.356 50.0931L79.8551 66.384C78.1471 68.8027 74.4301 67.5599 74.4301 64.5721V44.4397C74.4301 43.0922 73.3687 42 72.0592 42H67.3702C66.0607 42 64.9993 43.0922 64.9993 44.4397V133.56C64.9993 134.908 66.0607 136 67.3702 136H72.0592C73.3687 136 74.4301 134.908 74.4301 133.56V113.428C74.4301 110.44 78.1471 109.197 79.8551 111.616L91.356 127.907C92.1246 128.995 93.6049 129.238 94.6663 128.447L98.4606 125.609C99.5179 124.819 99.7538 123.291 98.9852 122.203L87.4844 105.912C85.7764 103.494 88.0741 100.238 90.8395 101.163L109.449 107.385C110.693 107.8 112.031 107.101 112.434 105.82L113.882 101.23C114.284 99.9492 113.605 98.5724 112.361 98.1581V98.1539Z",
    fill: "white"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBackgroundIcon);
export default __webpack_public_path__ + "static/media/logo-background-icon.5998d7f7ace960121ec0668da47fcf01.svg";
export { ForwardRef as ReactComponent };